/* istanbul ignore file */
import { readFromStorage, clearAll } from "./get-location/location-from-storage";
import { publishEvent, publishEventAtUrl, languageForApi, publishEventAtUrlV2, publishToEventHub } from "./network";
import { getLocationCoordinates } from "./get-location";
import lodash from "lodash";
import config from "../config.json";
import { _getItemFromSession } from "./Helpers/SessionKeys";
import { _getDeviceInfo, _getItemFromLocalDecrypted, _isMPINVerified } from "network-helper";
import { GUEST_USER } from "./Enums/jhh";
import { _getItemFromLocal } from "./LocalKeys";
import Bowser from "bowser";

export const logThisEvent = (eventData, errorObj = null) => {
    const eventName = "default";
    const serviceName = "event_tracker";
    const version = 1;
    const eventDate = new Date();
    let userId = GUEST_USER;
    if (_isMPINVerified()) {
        const { healthhub_id } = JSON.parse(_getItemFromLocalDecrypted("_cp"));
        userId = healthhub_id;
    }
    const data = {
        event_id: _getItemFromLocal("_jhh_lead_id"),
        event_name: eventName,
        service_name: serviceName,
        version: version,
        user_id: userId,
        tenant_id: _isMPINVerified() ? atob(_getItemFromSession("_tid")) : "",
        event_date: eventDate,
        event_subtype: errorObj ? "error" : "action",
        module: "survey",
        primary_source: _getItemFromLocal("primary_source") || "",
        payload: {
            lead_id: _getItemFromLocal("_jhh_lead_id"),
            primary_source: _getItemFromLocal("primary_source") || "",
            source: _getItemFromLocal("_sr") || (_getItemFromSession("_pnp") === "true" ? "PNP" : "JHH-WEBAPP"),
            page_name: _getItemFromLocal("page_name") || "",
            referrer: document?.referrer || "",
            misc: {
                device_info: Bowser?.parse(window.navigator.userAgent) || "",
            },
            eventData,
        },
    };
    if (errorObj) {
        data.payload.errorObj = errorObj;
    }
    data.payload = JSON.stringify(data.payload);
    const eventUrl = `${config.env}event-logging-service/v1/log/service/${serviceName}/event/${eventName}/version/${version}`;
    publishToEventHub(eventName, data, eventUrl);
};

export const fireSurveyResultEvent = async (language, riskResult, workflowResponses, essEventData) => {
    const eventName = "symptom_inference";
    const eventData = {
        language: languageForApi(language),
        question_id: "covid_19_risk",
        question_text: "covid_19_risk",
        response_id: lodash.get(riskResult, "meta_data.analytics_data.risk_id"),
        response_text: lodash.get(riskResult, "meta_data.analytics_data.risk_display_category"),
        risk_name: lodash.get(riskResult, "meta_data.analytics_data.risk_name"),
        action_category: lodash.get(riskResult, "meta_data.action_category"),
        workflow_responses: workflowResponses,
        ...essEventData,
    };

    if (Object.keys(essEventData).length) {
        const { latitude, longitude } = readFromStorage();
        clearAll();
        return publishEvent(eventName, { ...eventData }, { latitude, longitude });
    }
    clearAll();
    return publishEvent(eventName, eventData, getLocationCoordinates());
};

export const fireSurveyResultEventForMKT = async (workflowResponses) => {
    const eventData = workflowResponses;
    clearAll();
    return await publishEventAtUrlV2(eventData, config.surveyEventPublisher);
};

export const fireSurveyResultEventAtUrl = async (language, riskResult, workflowResponses, eventUrl) => {
    const eventName = "symptom_inference";
    let riskResultData = {};
    if (riskResult && riskResult.meta_data) {
        riskResultData = {
            response_id: riskResult.meta_data.analytics_data.risk_id,
            response_text: riskResult.meta_data.analytics_data.risk_display_category,
            risk_name: riskResult.meta_data.analytics_data.risk_name,
            action_category: riskResult.meta_data.action_category,
        };
    }
    const eventData = {
        language: languageForApi(language),
        question_id: "covid_19_risk",
        question_text: "covid_19_risk",
        ...riskResultData,
        workflow_responses: workflowResponses,
    };
    clearAll();
    return publishEventAtUrl(eventName, eventData, eventUrl);
};

export const firePageNavigationEvent = async (page) =>
    publishEvent(
        "page_navigation",
        {
            source_page: "home_page",
            destination_page: page,
        },
        getLocationCoordinates()
    );

export const fireStatsScreenEvent = async (selectedState, language, selectedCountry) => {
    const eventData = {
        language: languageForApi(language),
        selected_state: selectedState,
        selected_country: selectedCountry,
    };
    publishEvent("StatisticsScreen", eventData, getLocationCoordinates());
};

export const fireNoChangeEvent = async (essData) => {
    let location = getLocationCoordinates();
    if (!location.longitude) {
        location = {
            longitude: null,
            latitude: null,
        };
    }
    publishEvent("symptom_inference_no_change", essData, location);
};

export const fireQuickSurveyWithNoChangeEvent = async (language, workflowResponses, essEventData) => {
    const eventName = "symptom_inference_no_change";
    const eventData = {
        language: languageForApi(language),
        question_id: "covid_19_risk",
        question_text: "covid_19_risk",
        workflow_responses: workflowResponses,
        ...essEventData,
    };

    if (Object.keys(essEventData).length) {
        const { latitude, longitude } = readFromStorage();
        clearAll();
        return publishEvent(eventName, { ...eventData }, { latitude, longitude });
    }
    clearAll();
    return publishEvent(eventName, eventData, getLocationCoordinates());
};
